/*
 * Project: xpenser-client
 * FilePath: /src/app/components/auth-login/index.tsx
 * File: index.tsx
 * Created Date: Friday, September 18th 2020, 4:26:55 pm
 * Author: Craig Bojko (craig@pixelventures.co.uk)
 * -----
 * Last Modified: Fri Sep 18 2020
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2020 Pixel Ventures Ltd.
 * ------------------------------------
 * <<licensetext>>
 */

import React, { useEffect } from 'react'

interface ILoginComponent {
  url: string;
}

const LoginComponent: React.FC<ILoginComponent> = ({ url }) => {
  useEffect(() => {
    window.location.href = url
  }, [url])
  
  return (<p>Redirecting to login...</p>)
}

export default LoginComponent